import { Result, Button } from 'antd'

export default function ({ navigator }) {
  return <div className='min-h-screen flex items-center justify-center'>
    <Result
      status='404'
      title='404'
      subTitle='抱歉，您访问的页面不存在。'
      extra={<Button type='primary' onClick={() => navigator.back()}>返回</Button>}
    />
  </div>
}
